import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }

        let strength = 0;

        // Increase strength level for different character types
        if (/[a-z]/.test(value)) strength += 1;
        if (/[A-Z]/.test(value)) strength += 1;
        if (/[0-9]/.test(value)) strength += 1;
        if (/[\W_]/.test(value)) strength += 1;

        // Increase strength level for length
        if (value.length >= 8) strength += 1;
        if (value.length >= 12) strength += 1;

        const strong = strength >= 5;
        return strong ? null : { passwordStrength: 'Password is too weak' };
    };
}
